import { BusinessType } from "@/types/business/business";
import { BusinessInterface } from "@/interface/business/business";
import { PermissionsConstrains } from "@/enums/permissions.enum";
import { DateTimeManager } from "@/components/utils/library/date-manager/date-manager";

export class Business implements BusinessInterface {
  address: string = "";
  apps: Array<any> = [];
  contact_email?: string;
  country: string = "";
  created_at: string = "";
  currency: string = "";
  end_of_fiscal_day: string = "";
  environment: string = "";
  id: string = "";
  image: any;
  images: any;
  plan: any;
  profile: any;
  social: any;
  timezone: any;
  name: string = "";
  payment_gateways: Array<any> = [];
  phone: string = "";
  sender_email: string = "";
  services: Array<any> = [];
  type: string = "";
  updated_at: string = "";
  physicalDateTime: any = window.moment();

  public static MODULE = PermissionsConstrains.BUSINESS_BUSINESS;

  constructor(data?: BusinessType) {
    if (!data) {
      return;
    }

    Object.assign(this, data);

    if (data.image?.[256]) {
      data.image = data.image?.[256];
    }
    this.setupPhysicalDateTime(data);
    DateTimeManager.init(this.timezone.offset);
  }

  public getEndOfFinancialBusinessDateTime(): string {
    const todayRange = DateTimeManager.getTodayRange(this.end_of_fiscal_day);
    return DateTimeManager.getISODateFormat(todayRange[0]);
  }

  /***
   * Setup Physical Date Time
   * @param data
   * @private
   */
  private setupPhysicalDateTime(data) {
    if (data?.end_of_fiscal_day) {
      const splitBusinessTime = data.end_of_fiscal_day.split(":");
      this.physicalDateTime.set("hour", splitBusinessTime[0]);
      this.physicalDateTime.set("minute", splitBusinessTime[1]);
      this.physicalDateTime.set("second", splitBusinessTime[2]);
      // this.physicalDateTime = this.physicalDateTime.utc();
    }
  }

  /**
   * Business Image
   * @return {string}
   */
  getBusinessImage(): string {
    return !!this.image
      ? this.image["256"] || this.image
      : require("@/assets/images/empty-state/business-default-logo.svg");
  }
}
